import React, { useContext, createContext, useState, useEffect, useRef } from "react";

import {
	Route,
	Redirect
} from "react-router-dom";

import config from "./config";

import RoomClient from "./libs/RoomClient";
import RoomGlobal from "./libs/RoomGlobal";
import { Conversation } from "@elevenlabs/client";

import NoSleep from 'nosleep.js';

// RoomClient instance managing rooms and audio communications
let rc = null;

// RoomGlobal instance managing global messages
let rg = null;

let socket = null;
let socketMessage = null;

let mediasoupClient = null;
let remoteAudiosElem = null;
let aiConversation = null;

let noSleep = new NoSleep();

/**
Hook for child components to get the core object and re-render when it changes.
**/

const coreContext = createContext();

export function useCore() {

	return useContext( coreContext );

}


/**
Provider component that wraps your app and makes core object
available to any child component that calls useCore().
**/

export function ProvideCore( { children } ) {
	
	const [ authUser, setAuthUser ] = useState( null );

	const [ currentError, setCurrentError ] = useState( "" );
	const [ currentMessage, setCurrentMessage ] = useState( "" );

	const [ isLoading, setIsLoading ] = useState( false );
	const [ isUserReady, setIsUserReady ] = useState( false );
	const [ isInLogOut, setIsInLogOut ] = useState( false );

	const [ isOffline, setIsOffline ] = useState( false );
	
	const [ isTeacher, setTeacher ] = useState( false );
	
	const [ openSendAttachment, setOpenSendAttachment ] = useState( null );
	const [ openActiveAttachment, setOpenActiveAttachment ] = useState( null );
	const [ activeAttachments, setActiveAttachments ] = useState( null );

	const [ isRecording, setIsRecording ] = useState( [] );
	const [ activeRecordings, setActiveRecordings ] = useState( null );
	const [ previewRecording, setPreviewRecording ] = useState( null );
	const [ openActiveRecordings, setOpenActiveRecordings ] = useState( false );
	const [ selectedRecordings, setSelectedRecordings ] = useState( null );

	const [ currentLesson, setCurrentLesson ] = useState( null );
	const [ currentLessonAttachments, setCurrentLessonAttachments ] = useState( null );	

	const [ currentQuiz, setCurrentQuiz ] = useState( null );
	const [ currentQuizIndex, setCurrentQuizIndex ] = useState( 0 );
	const [ currentExecution, setCurrentExecution ] = useState( null );

	const [ globalRoomUsers, setGlobalRoomUsers ] = useState( {} );
	const [ activeGroups, setActiveGroups ] = useState( {} );
	const [ currentUserGroup, setCurrentUserGroup ] = useState( "0" );
	const [ currentGroupDetails, setCurrentGroupDetails ] = useState( null );

	const [ openSideBar, setOpenSideBar ] = useState( false );
  	const [ openCloud, setOpenCloud ] = useState( false );
        const [ openSideAttachment, setOpenSideAttachment ] = useState( false );
	const [ isAiTutorOpen, setIsAiTutorOpen ] = useState( false );
	const [ aiTutorStatus, setAiTutorStatus ] = useState( 'disconnected' );
	const [ aiTutorMode, setAiTutorMode ] = useState( 'idle' );
	const [ aiTutorIsSpeaking, setAiTutorIsSpeaking ] = useState( false );

        const [ isScreenSharing, setIsScreenSharing ] = useState( false );
        const [ localScreenStream, setLocalScreenStream ] = useState( null );
        const [ remoteScreenStream, setRemoteScreenStream ] = useState( null );
        const [ remoteScreenOwner, setRemoteScreenOwner ] = useState( null );
        const [ shouldResumeScreenShare, setShouldResumeScreenShare ] = useState( false );
	const [ screenShareRequest, setScreenShareRequest ] = useState( null );

        const refAuth = useRef();
        refAuth.current = authUser;

        const refGlobalUsers = useRef();
        refGlobalUsers.current = globalRoomUsers;

        const refCurrentUserGroup = useRef();
        refCurrentUserGroup.current = currentUserGroup;

        const resumeScreenShareRef = useRef( false );
        const forcedShareAudioRef = useRef( false );
	const aiTutorSpeakingTimeoutRef = useRef( null );
	const aiTutorOutputMonitorRef = useRef( null );

	/* On Load */

	useEffect( () => {

		remoteAudiosElem = document.getElementById( 'remoteAudios' );

		socket = window.globalSocket;
		socketMessage = window.globalSocketMessage;
		mediasoupClient = window.globalMediasoupClient;

		socket.request = function request(type, data = {}) {
			return new Promise((resolve, reject) => {
				socket.emit(type, data, (data) => {
					if (data.error) {
						reject(data.error)
					} else {
						resolve(data)
					}
				})
			})
		};

		socketMessage.request = function request(type, data = {}) {
			return new Promise((resolve, reject) => {
				socketMessage.emit(type, data, (data) => {
					if (data.error) {
						reject(data.error)
					} else {
						resolve(data)
					}
				})
			})
		};

		const storedUser = JSON.parse( localStorage.getItem('opedialingue_user') );
				
		console.log( 'storedUser:', storedUser );

		setUserData( storedUser );

		setTeacher( storedUser ? storedUser.isTeacher : false );

		if ( storedUser ) {

			if ( isMobileDevice() ) enableNoSleep();

			currentUserJoin( storedUser );

		}
		
		window.addEventListener( 'online', onOnline );
		window.addEventListener( 'offline', onOffline );

		const onTutorUnhandledRejection = ( event ) => {

			const reason = event && event.reason;
			const message = typeof reason === 'string'
				? reason
				: ( reason && ( reason.message || reason.reason || reason.error ) ) || '';
			const stack = reason && reason.stack ? String( reason.stack ) : '';
			const normalized = ( message + ' ' + stack ).toLowerCase();

			if ( !normalized.includes( 'error_type' ) && !normalized.includes( 'baseconversation' ) ) return;

			console.error( 'Tutor AI unhandled rejection captured:', reason );

			if ( aiTutorSpeakingTimeoutRef.current ) {
				clearTimeout( aiTutorSpeakingTimeoutRef.current );
				aiTutorSpeakingTimeoutRef.current = null;
			}

			if ( aiTutorOutputMonitorRef.current ) {
				clearInterval( aiTutorOutputMonitorRef.current );
				aiTutorOutputMonitorRef.current = null;
			}

			aiConversation = null;
			setIsAiTutorOpen( false );
			setAiTutorStatus( 'disconnected' );
			setAiTutorMode( 'idle' );
			setAiTutorIsSpeaking( false );
			setCurrentError( 'Tutor AI disconnesso per errore SDK ElevenLabs. Possibile quota esaurita. Dettaglio: ' + ( message || 'errore non specificato' ) );

		};

		window.addEventListener( 'unhandledrejection', onTutorUnhandledRejection );

		// TODO -- non va bene crea problemi, scatta più volte e anche dopo un po' di tempo che si ricarica...
		/*
		navigator.mediaDevices.ondevicechange = ( event ) => {
            
			console.warn( '*** ondevicechange', event );

			// TODO -- vedere se è possibile usare il nuovo microfono senza far fare il reload.
			alert( 'Attenzione! È stato rilevato un cambio di microfono. Per un corretto funzionamento ricaricare la pagina.' );

		};
		*/

		/* On UnLoad */
		return () => {

			window.removeEventListener( 'online', onOnline );
			window.removeEventListener( 'offline', onOffline );
			window.removeEventListener( 'unhandledrejection', onTutorUnhandledRejection );

		}

    }, [] );

	/* On Update */

	useEffect( () => {

		console.log( 'hook update isUserReady:', isUserReady, authUser );

		if ( isUserReady && !isInLogOut ) loadStoredData( authUser );

	}, [ isUserReady ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update currentLesson:', currentLesson );

			if ( authUser ) {

				let user = { ...authUser };

				user.currentLesson = currentLesson;

				setUserData( user );

			}

			if ( isTeacher ) {

				const msg = {
					type: 'lesson',
					data: currentLesson
				};

				if ( rg ) rg.sendMessage( msg );

			}

		}

	}, [ currentLesson ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update activeAttachments:', activeAttachments );

			if ( authUser ) {

				let user = { ...authUser };

				user.activeAttachments = activeAttachments;

				setUserData( user );

			}

		}

	}, [ activeAttachments ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update currentLessonAttachments:', currentLessonAttachments );

			if ( authUser && isTeacher ) {

				let user = { ...authUser };

				user.currentLessonAttachments = currentLessonAttachments;

				setUserData( user );

			}

		}

	}, [ currentLessonAttachments ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update activeGroups:', activeGroups );

			if ( authUser ) {

				let user = { ...authUser };

				user.activeGroups = activeGroups;

				setUserData( user );

			}

		}

	}, [ activeGroups ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update currentUserGroup:', currentUserGroup );

			if ( authUser ) {

				let user = { ...authUser };

				user.currentUserGroup = currentUserGroup;

				setUserData( user );

			}

		}

	}, [ currentUserGroup ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update activeRecordings:', activeRecordings );

			if ( authUser && isTeacher ) {

				let user = { ...authUser };

				user.activeRecordings = activeRecordings;

				setUserData( user );

			}

		}

	}, [ activeRecordings ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update currentQuiz:', currentQuiz );

			if ( authUser ) {

				let user = { ...authUser };

				user.currentQuiz = currentQuiz;

				setUserData( user );

			}

			// TODO -- vertificare cosa se bisogna pulire/chiudere qualcosa prima di iniziare il quiz
			// es: se ci sono registrazioni in corso?
			// es: se ci sono gruppi composti bisogna riportare tutti in classe (pause?)

			if ( isTeacher ) {

				const msg = {
					type: 'updatequiz',
					data: currentQuiz
				};

				if ( rg ) rg.sendMessage( msg );

			}

		}

	}, [ currentQuiz ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update currentExecution:', currentExecution );

			if ( authUser ) {

				let user = { ...authUser };

				user.currentExecution = currentExecution;

				setUserData( user );

			}
		
		}

	}, [ currentExecution ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update globalRoomUsers:', globalRoomUsers );

			if ( isTeacher ) {

				// save global status

				let user = { ...authUser };

				user.globalRoomUsers = globalRoomUsers;

				setUserData( user );

				// send update msg to students

				const msg = {
					type: 'updatedata',
					data: {
						currentLesson: currentLesson,
						activeAttachments: activeAttachments,
						currentQuiz: currentQuiz
					}
				};

				if ( rg ) rg.sendMessage( msg );

			}

		}

	}, [ globalRoomUsers ] );

	useEffect( () => {

		if ( isUserReady ) {

			console.log( 'hook update isRecording:', isRecording );

			let recList = [ ...isRecording ];

			if ( recList.length ) {

				if ( recList[ currentUserGroup ] === true ) {

					const media_id = activeAttachments[ currentUserGroup ].media_id;
					const desc = activeAttachments[ currentUserGroup ].desc;

					console.log(' Sending START_RECORDING...', media_id, desc );
					
					socket.emit( 'START_RECORDING', {
						media_id, 
						desc
					} );
				
				}
				else {

					console.log( 'Sending STOP_RECORDING...' );

					setIsLoading( true );
					
					socket.emit( 'STOP_RECORDING', function( esercitazione_id, end_timestamp, esercitazione ) {

						setIsLoading( false );

						console.log( '*** Recording Data', esercitazione_id, end_timestamp );
						console.log( '*** Esercitazione', JSON.stringify( esercitazione ) );

						sendFinalizeRec( currentUserGroup, refAuth.current.session_id, esercitazione_id, end_timestamp, esercitazione );

					} );

				}
			}

		}

	}, [ isRecording ] );

	/* */

	const onBlur = () => {

		//console.log( '*** blur' );

		const msg = {
			type: 'inactive',
			data: {
				user: refAuth.current.name
			}
		};

		if ( rg ) rg.sendMessage( msg );

	};

	const onFocus = () => {

		//console.log( '*** focus' );

		const msg = {
			type: 'active',
			data: {
				user: refAuth.current.name
			}
		};

		if ( rg ) rg.sendMessage( msg );

	};

	// TODO -- disabilitato perché provoca perdita di funzionalità se si preme "annulla"
	const onBeforeUnload = ( event ) => {

		console.log( '*** beforeunload' );

		event.preventDefault();
		event.returnValue = '';
		delete event['returnValue'];

	};

	const onOnline = () => {

		console.log( '*** online' );

		if ( refAuth && refAuth.current ) {

			// restore active session

			console.log( 'isTeacher:', refAuth.current.isTeacher );

			setCurrentUserGroup( "0" );

			let reloadTimeout = 0;

			if ( !refAuth.current.isTeacher ) reloadTimeout = 4000;

			setTimeout( () => {

				setIsOffline( false );

				window.location.reload();
				
			}, reloadTimeout );

		}
		else {

			// reload

			window.location.reload();

		}

	};

	const onOffline = () => {

		console.log( '*** offline' );

		setIsOffline( true );

	};

	/* */

	const loadStoredData = ( userData ) => {

		console.log( 'loadStoredData:', userData );
		console.log( 'globalRoomUsers:', globalRoomUsers );

		if ( userData ) {

			if ( userData.currentLesson ) setCurrentLesson( userData.currentLesson );
			if ( userData.activeAttachments ) setActiveAttachments( userData.activeAttachments );
			if ( userData.currentLessonAttachments ) setCurrentLessonAttachments( userData.currentLessonAttachments );
			if ( userData.activeRecordings ) setActiveRecordings( userData.activeRecordings );

			// TODO -- attenzione, qua ricarica sempre il quiz, pure se è stato terminato...
			if ( userData.currentQuiz ) setCurrentQuiz( userData.currentQuiz );
			if ( userData.currentExecution ) setCurrentExecution( userData.currentExecution );
			
			// TODO -- perché non ricarica le info relative ai gruppi?? probabilmente il problema è che i gruppi possono cambiare nel momento in cui lo studente lascia e poi si ricollega!
			// in più gli utenti si riconnettono sempre dalla room 0, i gruppi dovrebbero essere applicati successivamente
			//if ( userData.currentUserGroup ) setCurrentUserGroup( userData.currentUserGroup );
			//if ( userData.activeGroups ) setActiveGroups( userData.activeGroups );

                        const storedScreenShare = userData.isScreenSharing || userData.isSharing;

                        if ( storedScreenShare && userData.isTeacher ) {

                                resumeScreenShareRef.current = true;
                                setShouldResumeScreenShare( true );

                        }
                        else {

                                resumeScreenShareRef.current = false;

                        }

			if ( userData.isTeacher ) {

				// TODO -- non basta settare i gruppi, deve aggiornare la sua situazione dei global room users 
				// il problema è che appena fa reload il docente vede globalRoomUsers vuota se gli studenti sono nei gruppi
				// ricaricare però i globalRoomUsers è un'operazione potenzialmente pericolosa nel caso di cambi mentre si sta ricaricando

				if ( userData.activeGroups ) setActiveGroups( userData.activeGroups );
				if ( userData.globalRoomUsers ) setGlobalRoomUsers( userData.globalRoomUsers );

				/*
				const msg = {
					type: 'resetgroups'
				};
		
				if ( rg ) rg.sendMessage( msg );

				// TODO -- qui al momento azzera tutti gli attachments
				setActiveAttachments( null );
				*/

			}
			else {

				if ( userData.currentUserGroup && userData.currentUserGroup !== "0" ) {
					
					changeGroup( userData.name, userData.currentUserGroup );
					sendChangeGroupMsg( userData.name, userData.currentUserGroup );

				}

			}

			// TODO -- verificare se effettivamente si può fare a meno del controllo sulla presenza del docente, forse per situazioni anomale si può controllare il numero di sessione invece che il docente
			// TODO -- il controllo serviva ad esempio nel caso in cui gli studenti chiudono senza fare logout (o va via la connession), il docente chiude la sessione, gli studenti ricaricano la pagina e si ritrovano nella vecchia sessione ma senza docente

			/*
			// check for not correctly cleaned sessions
			let foundTeacher = false;

			for ( const [ k, user ] of Object.entries( globalRoomUsers ) ) {

				if ( user.isTeacher ) foundTeacher = true;

			}

			console.log('**** foundTeacher', foundTeacher);

			if ( !userData.isTeacher && !foundTeacher ) {

				setIsLoading( false );

				setCurrentError('ATTENZIONE! Docente non trovato. Qualcosa è andato storto durante il caricamento della sessione o la precedente sessione non era stata chiusa correttamente. Riprovare a collegarsi.');

				sendLogout();

			}
			else {

				//setTimeout( function() {

					if ( userData.currentLesson ) setCurrentLesson( userData.currentLesson );
					if ( userData.activeAttachments ) setActiveAttachments( userData.activeAttachments );
					if ( userData.currentLessonAttachments ) setCurrentLessonAttachments( userData.currentLessonAttachments );
					if ( userData.activeRecordings ) setActiveRecordings( userData.activeRecordings );

					// TODO -- attenzione, qua ricarica sempre il quiz, pure se è stato terminato...
					if ( userData.currentQuiz ) setCurrentQuiz( userData.currentQuiz );
					if ( userData.currentExecution ) setCurrentExecution( userData.currentExecution );
					
					// TODO -- perché non ricarica le info relative ai gruppi?? probabilmente il problema è che i gruppi possono cambiare nel momento in cui lo studente lascia e poi si ricollega!
					// in più gli utenti si riconnettono sempre dalla room 0, i gruppi dovrebbero essere applicati successivamente
					//if ( userData.currentUserGroup ) setCurrentUserGroup( userData.currentUserGroup );
					//if ( userData.activeGroups ) setActiveGroups( userData.activeGroups );

					// TODO -- soluzione momentanea, se docente fa reload invia a tutti un messaggio di "reset" situazione gruppi
					if ( userData.isTeacher ) {

						const msg = {
							type: 'resetgroups'
						};
				
						if ( rg ) rg.sendMessage( msg );

						// TODO -- qui al momento azzera tutti gli attachments
						setActiveAttachments( null );

					}
					else {

						if ( userData.currentUserGroup && userData.currentUserGroup !== "0" ) {
							
							changeGroup( userData.name, userData.currentUserGroup );
							sendChangeGroupMsg( userData.name, userData.currentUserGroup );

						}

					}

					setIsLoading( false );

				//}, config.TIMEOUT_DELAY );

			}
			*/

		}

	};

	/* */

	const openAttachment = ( media, attach ) => {

		console.log( 'openAttachment:', media, attach );

		attach.type = media;

		setOpenSendAttachment( attach );

	};

	/* */

	const sendAttachmentMsg = ( attach ) => {

		console.log( '*** sendAttachmentMsg', attach );

		const msg = {
			type: 'attachment',
			data: attach
		};

		if ( rg ) rg.sendMessage( msg );

	}

	/* */
	
	const enableNoSleep = () => {

		if ( noSleep ) noSleep.enable();

		console.log( 'noSleep enable:', noSleep );

	};

	/* */
	
	const disableNoSleep = () => {

		if ( noSleep ) noSleep.disable();

		console.log( 'noSleep enable:', noSleep );

		noSleep = null;

	};

	/* */
	
	const currentUserJoin = ( user ) => {

		try {

			// First join in classroom

			console.log( 'currentUserJoin:', user );

			joinGlobal( user.name, user.isTeacher, user.session_id );

		}
		catch( e ) {

			console.error( 'Error during currentUserJoin:', e );

			alert( 'Error during currentUserJoin: ' + e );

			sendSessionLog( 'Error during currentUserJoin: ' + e );

			// In caso di un qualsiasi errore nella join viene forzato il logout
			sendLogout();

		}

	};

	/* */

	const currentUserLeave = () => {

		if ( refAuth.current ) {

			console.log( 'currentUserLeave', refAuth.current.name );

			const msg = {
				type: 'globaldelete',
				data: {
					user: refAuth.current.name
				}
			};

			if ( rg ) rg.sendMessage( msg );

			setIsLoading( true );

			setTimeout( function() {

				if ( rg ) rg.exit( false, refAuth.current.isTeacher );

				rg = null;

				closeLocalAudio();

				cleanUserData();

				setIsLoading( false );
		
			}, config.TIMEOUT_DELAY );

		}

	};

	/* */

	const addGlobalUser = ( name, is_teacher, room_id ) => {

		let userList = { ...refGlobalUsers.current };

                userList[ name ] = {
                        id: name,
                        name: name,
                        isTeacher: is_teacher,
                        isTalking: false,
                        isActive: true,
                        hasQuizDone: false,
                        isSharing: false,
                        room: room_id
                };

		setGlobalRoomUsers( userList );

	};

	/* */

	const removeGlobalUser = ( name ) => {

		let userList = { ...refGlobalUsers.current };

		if ( userList[ name ] ) delete userList[ name ];

		setGlobalRoomUsers( userList );

	};

	/* 
		changeGroup:
		Used to change a user group and join the related room or to update users room status.
	*/

	const changeGroup = ( user, group, reset ) => {

		console.log( 'Current user:', refAuth.current.name );
		console.log( 'changeGroup:', user, group, reset );		
		
		if ( refAuth.current.name === user ) {

			// Conferma manuale inserita per ritardare ed evitare passaggio in massa degli studenti
			/*
			if ( !refAuth.current.isTeacher && group === '0' ) {

				if ( reset ) alert( 'Il docente ha riavviato la sessione. Confermare per tornare in classe.' );
				else alert( 'Il docente ha chiuso la sessione del gruppo. Confermare per tornare in classe.' );
			
			}
			*/

			// random delay (da 10ms a 50ms) dopo conferma, per evitare maggiormente la possibilità di chiamate contemporanee
			setTimeout(() => {

				setCurrentUserGroup( group );

				console.log( '*** exit current room' );

				if ( rc ) rc.exit( false, function() {

					console.log('*** room exit done...');

					setIsLoading( true );

					setTimeout(() => {

						setIsLoading( false );

						joinRoom( refAuth.current.name, refAuth.current.isTeacher, group, refAuth.current.cloud_id, refAuth.current.session_id );
						
					//}, 150 );
					}, config.TIMEOUT_DELAY );

				} );

				rc = null;

			}, config.TIMEOUT_DELAY + Math.random() * ( 50 - config.TIMEOUT_DELAY ) );
			
		}
		else {
				
			let users = { ...refGlobalUsers.current };

			console.log( '*** update users', users );

			users[ user ].room = group;

			setGlobalRoomUsers( users );

		}

	};

	/* 
		sendChangeGroupMsg:
		Used by the teacher to send students a request to change group.
	*/
	
	const sendChangeGroupMsg = ( user, group ) => {

		console.log( '*** sendChangeGroupMsg', user, group );

		const msg = {
			type: 'changegroup',
			data: { 
				user: user, 
				group: group
			}
		};

		if ( rg ) rg.sendMessage( msg );

	};

	/* */

        const userGlobalTalk = ( user, isTalking ) => {

                const userList = { ...( refGlobalUsers.current || {} ) };

                let hasChanges = false;

                if ( userList[ user ] ) {
                        if ( userList[ user ].isTalking !== isTalking ) {
                                userList[ user ] = { ...userList[ user ], isTalking };
                                hasChanges = true;
                        }
                }

                if ( hasChanges ) setGlobalRoomUsers( userList );

                if ( refAuth.current && refAuth.current.name === user && refAuth.current.isTalking !== isTalking ) {
                        const updatedUser = { ...refAuth.current, isTalking };
                        setUserData( updatedUser );
                }

        };

	/* */

	const userGlobalShare = ( user, isSharing ) => {

		let userList = { ...refGlobalUsers.current };

		if ( userList[ user ] ) userList[ user ].isSharing = isSharing;

		setGlobalRoomUsers( userList );

	};

	/* */

	const userGlobalQuizDone = ( user, hasQuizDone ) => {

		let userList = { ...refGlobalUsers.current };

		if ( userList[ user ] ) userList[ user ].hasQuizDone = hasQuizDone;

		setGlobalRoomUsers( userList );

	};

	/* */

	const userGlobalActive = ( user, isActive ) => {

		let userList = { ...refGlobalUsers.current };

		if ( userList[ user ] ) userList[ user ].isActive = isActive;

		setGlobalRoomUsers( userList );

	};

	/* */

	const userKickOff = ( id ) => {

		if ( window.confirm( 'Sei sicuro di voler disconnettere questo utente?' ) ) {

			console.log( 'userKickOff:', id );

			const msg = {
				type: 'kickoff',
				data: {
					user: id
				}
			};

			if ( rg ) rg.sendMessage( msg );

		}

	};

	/* */

	const kickOffAll = ( id ) => {

		console.log( 'kickOffAll' );

		const msg = {
			type: 'kickoffall'
		};

		if ( rg ) rg.sendMessage( msg );

	};

	/* */	
  
	const setUserData = ( data ) => {
		
		console.log( 'setUserData:', data );
		
		if ( data ) {
		
			localStorage.setItem( 'opedialingue_user', JSON.stringify( data ) );			
			
			setAuthUser( data );
		
		}
		else {
			
			localStorage.removeItem( 'opedialingue_user' );
			
			setAuthUser( null );
			
		}
		
	};

	/* */

	async function sendFinalizeRec( room_id, session_id, esercitazione_id, end_timestamp, esercitazione ) {		

		let recordings = { ...activeRecordings };

		if ( !recordings[ room_id ] ) {

			recordings[ room_id ] = {};
			recordings[ room_id ][ esercitazione_id ] = {};

		}
		else if ( !recordings[ room_id ][ esercitazione_id ] ) {

			recordings[ room_id ][ esercitazione_id ] = {};

		}

		console.log( 'Recordings:', recordings );

		try {

			setIsLoading( true );

			const params = {
				room_id: room_id, 
				session_id: session_id, 
				esercitazione_id: esercitazione_id, 
				end_timestamp: end_timestamp, 
				esercitazione: esercitazione
			};
			
			const endpoint = config.API_BASENAME + '/finalize-rec/';
			const apiData = await apiRequest( endpoint, 'POST', refAuth.current.tokenDjango, params );
			
			console.log( 'apiData:', apiData );

			setIsLoading( false );
			
			if ( apiData.result === "error" ) {
				
				setCurrentError( 'Errore durante la procedura di invio registrazione.' );
				
			}
			else { 

				console.log( 'Audio File:', apiData.audio_file );	

				setPreviewRecording( apiData.audio_file );

				setOpenActiveAttachment( null );

				recordings[ room_id ][ esercitazione_id ].audio_file = apiData.audio_file;

				console.log( 'Recordings:', recordings );

				setActiveRecordings( recordings );

			}
			
		} catch( err ) {
			
			console.error( 'Error sendFinalizeRec:', err );

			setCurrentError( 'Error sendFinalizeRec: ' + err );

			setIsLoading( false );
		
		}
		
	};

	/* */

	async function sendSaveLesson() {

		if ( selectedRecordings ) {

			try {

				setIsLoading( true );

				const params = {
					lesson_id: currentLesson.id,
					lesson_title: currentLesson.titolo,
					session_id: refAuth.current.session_id,
					esercitazioni: selectedRecordings
				};
				
				const endpoint = config.API_BASENAME + '/save-lesson/';
				const apiData = await apiRequest( endpoint, 'POST', refAuth.current.tokenDjango, params );
				
				console.log( 'apiData:', apiData );

				setIsLoading( false );
				
				if ( apiData.result === "error" ) {
					
					setCurrentError( 'Errore durante il salvataggio dello svolgimento.' );
					
				}
				else { 

					setOpenSideBar( false );
					setOpenActiveRecordings( false );

					// Remove selected recordics from active recordings

					let active = { ...activeRecordings };

					Object.entries( selectedRecordings ).map( ( [ room, recordings ] ) => {

						Object.entries( recordings ).map( ( [ index, track ] ) => {

							delete active[ room ][ index ];

						} );

						if ( Object.keys( active[ room ] ).length === 0 ) delete active[ room ];
			
					} );

					if ( Object.keys( active ).length === 0 ) setActiveRecordings( null );
					else setActiveRecordings( active );
					
					setSelectedRecordings( null );

					setCurrentMessage( 'Svolgimenti selezionati salvati correttamente!' );

				}
				
			} catch( err ) {
				
				console.error( 'Error during sendSaveLesson:', err );

				setCurrentError( 'Error during sendSaveLesson: ' + err );

				setIsLoading( false );
			
			}

		}

	};

	/* */

	const quizDone = () => {

		// Student

		console.log('*** quizDone' );

		setCurrentQuiz( null );
		setCurrentQuizIndex( 0 );
		setCurrentExecution( null );

		let user = { ...authUser };

		user.hasQuizDone = true;

		//setAuthUser( user );
		setUserData( user );
		
		const msg = {
			type: 'quizdone',
			data: {
				user: refAuth.current.name
			}
		};
	
		if ( rg ) rg.sendMessage( msg );

		sendSaveExecution();

	};

	/* */

	const quizClose = () => {

		// Teacher

		console.log('*** quizClose' );
		
		for ( const [ k, user ] of Object.entries( globalRoomUsers ) ) {

			userGlobalQuizDone( user.name, false );

		}

		setCurrentQuiz( null );

	};

	/* */

	function prepareCurrentExecution( message ) {

		message.username = refAuth.current.name;
		message.user_id = refAuth.current.cloud_id;

		for ( let exe of message.exercises ) {

			// Drag & Drop
			if ( exe.type === "9" ) {

				exe.draggables = [];

				const shuffledAnswers = shuffleArray( exe.answers );

				for ( const item of shuffledAnswers ) {

					let draggables = item.text.match( /\[\[(.*?)\]\]/g );
		
					if ( draggables ) {
		
						draggables = shuffleArray( draggables );
						
						for ( const dragItem of draggables ) {
		
							exe.draggables.push( dragItem.replaceAll( /\[\[/g, '' ).replaceAll( /\]\]/g, '' ) );
		
						}
		
					}
		
				}

			}

		}

		console.log( 'prepareCurrentExecution:', message );

		setCurrentExecution( message );

	};

	/* */

	async function sendSaveExecution() {

		console.log('**** currentExecution', currentExecution );

		try {

			setIsLoading( true );

			// clean data
			let execution = { ...currentExecution };

			for ( let i = 0; i < execution.exercises.length; i++ ) {

				// Completamento libero
				if ( execution.exercises[ i ].type === "7" && execution.exercises[ i ].answers ) {

					for ( let k = 0; k < execution.exercises[ i ].answers.length; k++ ) {

						if ( execution.exercises[ i ].answers[ k ].items ) {
					
							const cleaned = execution.exercises[ i ].answers[ k ].items.filter( function( el ) {
								return el != null;
							} );

							execution.exercises[ i ].answers[ k ].items = cleaned;

						}

					}

				}

				// Drag & Drop
				if ( execution.exercises[ i ].type === "9" && execution.exercises[ i ].answers ) {

					for ( let k = 0; k < execution.exercises[ i ].answers.length; k++ ) {

						if ( execution.exercises[ i ].answers[ k ].selection ) {
					
							const cleaned = execution.exercises[ i ].answers[ k ].selection.filter( function( el ) {
								return el != null;
							} );

							execution.exercises[ i ].answers[ k ].selection = cleaned;

						}

					}

				}

			}

			const params = execution;

			console.log('**** Execution JSON', JSON.stringify( execution ) );
			
			// TEST ....
			const endpoint = config.API_BASENAME + '/quiz/' + currentQuiz.quiz.id + '/answers/';
			const apiData = await apiRequest( endpoint, 'POST', authUser.tokenDjango, params );
			
			console.log( 'apiData:', apiData );

			setIsLoading( false );
			
			if ( apiData.result === "error" ) {
				
				setCurrentError( 'Errore durante il caricamento dello svolgimento quiz.' );
				
			}
			else { 

				// done...

			}
			
		} catch( err ) {
			
			console.error( 'Error during sendSaveExecution:', err );

			setCurrentError( 'Error during sendSaveExecution: ' + err );

			setIsLoading( false );
		
		}

	};

	/* */

	async function sendLogout() {		
		
		try {

			setIsLoading( true );
			setIsInLogOut( true );

			const params = {
				teacher_id: refAuth.current.isTeacher ? refAuth.current.cloud_id : 0,
				student_id: !refAuth.current.isTeacher ? refAuth.current.cloud_id : 0,
				school_id: refAuth.current.school_id,
				session_id: refAuth.current.session_id
			};
			
			const endpoint = config.API_BASENAME + '/logout/';
			const apiData = await apiRequest( endpoint, 'POST', refAuth.current.tokenDjango, params );
			
			console.log( 'apiData:', apiData );

			setIsLoading( false );

			setIsInLogOut( false );
			
			if ( apiData.result === "error" ) {
				
				setCurrentError( 'Errore durante la procedura di logout.' );

				//cleanUserData();
				
			}
			else { 

				if ( isTeacher ) kickOffAll();

			}

			currentUserLeave();	
			
		} catch( err ) {
			
			console.error( 'Error during sendLogout:', err );

			setCurrentError( 'Error during sendLogout: ' + err );

			setIsLoading( false );

			setIsInLogOut( false );

			//cleanUserData();
			currentUserLeave();	
		
		}
		
	};

	/* */

	const stopAiTutorSession = async ( options = {} ) => {

		const {
			silent = false,
			suppressErrors = false
		} = options;

		const activeConversation = aiConversation;
		aiConversation = null;

		if ( aiTutorSpeakingTimeoutRef.current ) {
			clearTimeout( aiTutorSpeakingTimeoutRef.current );
			aiTutorSpeakingTimeoutRef.current = null;
		}

		if ( aiTutorOutputMonitorRef.current ) {
			clearInterval( aiTutorOutputMonitorRef.current );
			aiTutorOutputMonitorRef.current = null;
		}

		if ( activeConversation && typeof activeConversation.endSession === 'function' ) {

			try {

				await activeConversation.endSession();

			} catch ( err ) {

				console.error( 'Error during stopAiTutorSession:', err );

				if ( !suppressErrors ) setCurrentError( 'Errore durante la chiusura del Tutor AI.' );

			}

		}

		setAiTutorStatus( 'disconnected' );
		setAiTutorMode( 'idle' );
		setAiTutorIsSpeaking( false );
		setIsAiTutorOpen( false );

	};

	/* */

	const startAiTutorSession = async () => {

		if ( !config.ELEVENLABS_AGENT_ID ) {

			setCurrentError( 'Configurazione Tutor AI mancante: impostare ELEVENLABS_AGENT_ID in src/config.js.' );
			return false;

		}

		if ( aiConversation || aiTutorStatus === 'connecting' || aiTutorStatus === 'connected' ) return true;

		try {

			setIsAiTutorOpen( true );
			setAiTutorStatus( 'connecting' );
			setAiTutorMode( 'idle' );
			setAiTutorIsSpeaking( false );
			console.log( 'Tutor AI start requested', {
				agentId: config.ELEVENLABS_AGENT_ID,
				userId: refAuth.current ? String( refAuth.current.cloud_id || refAuth.current.name ) : undefined
			} );

			if ( refAuth.current && refAuth.current.isTalking ) await playMute( false );

			const userId = refAuth.current
				? String( refAuth.current.cloud_id || refAuth.current.name )
				: undefined;

			aiConversation = await Conversation.startSession( {
				agentId: config.ELEVENLABS_AGENT_ID,
				connectionType: 'webrtc',
				userId,
				onConnect: () => {
					setAiTutorStatus( 'connected' );
					setIsAiTutorOpen( true );

					if ( aiTutorOutputMonitorRef.current ) clearInterval( aiTutorOutputMonitorRef.current );

					aiTutorOutputMonitorRef.current = setInterval( () => {
						if ( !aiConversation || typeof aiConversation.getOutputVolume !== 'function' ) return;

						const outputVolume = aiConversation.getOutputVolume();
						if ( outputVolume > 0.005 ) {
							setAiTutorIsSpeaking( true );

							if ( aiTutorSpeakingTimeoutRef.current ) clearTimeout( aiTutorSpeakingTimeoutRef.current );
							aiTutorSpeakingTimeoutRef.current = setTimeout( () => {
								setAiTutorIsSpeaking( false );
							}, 380 );
						}
					}, 140 );
				},
					onDisconnect: ( details ) => {
						console.error( 'Tutor AI onDisconnect:', details );
						aiConversation = null;

						if ( aiTutorOutputMonitorRef.current ) {
							clearInterval( aiTutorOutputMonitorRef.current );
							aiTutorOutputMonitorRef.current = null;
						}
						setAiTutorStatus( 'disconnected' );
						setAiTutorMode( 'idle' );
						setAiTutorIsSpeaking( false );
						setIsAiTutorOpen( false );

						if ( details && details.reason === 'error' ) {
							const disconnectMessage = details.message || details.closeReason || 'disconnessione con errore';
							setCurrentError( 'Tutor AI disconnesso: ' + disconnectMessage );
						}
					},
					onStatusChange: ( statusInfo ) => {

					const nextStatusRaw = typeof statusInfo === 'string' ? statusInfo : statusInfo && statusInfo.status;
					const nextStatus = nextStatusRaw ? String( nextStatusRaw ).toLowerCase() : null;
					if ( nextStatus ) {
						console.log( 'Tutor AI status:', nextStatus );
						setAiTutorStatus( nextStatus );
						setIsAiTutorOpen( nextStatus !== 'disconnected' && nextStatus !== 'disconnecting' );
					}

				},
					onModeChange: ( modeInfo ) => {

						const nextModeRaw = typeof modeInfo === 'string' ? modeInfo : modeInfo && modeInfo.mode;
						const nextMode = nextModeRaw ? String( nextModeRaw ).toLowerCase() : null;
						if ( nextMode ) {
							console.log( 'Tutor AI mode:', nextMode );
							setAiTutorMode( nextMode );
							setAiTutorIsSpeaking( nextMode.includes( 'speak' ) );
						}

					},
					onAudio: () => {

						setAiTutorIsSpeaking( true );

						if ( aiTutorSpeakingTimeoutRef.current ) clearTimeout( aiTutorSpeakingTimeoutRef.current );

						aiTutorSpeakingTimeoutRef.current = setTimeout( () => {
							setAiTutorIsSpeaking( false );
						}, 420 );

					},
					onMessage: ( messageInfo ) => {

						if ( !messageInfo || messageInfo.role !== 'agent' ) return;

						setAiTutorIsSpeaking( true );

						if ( aiTutorSpeakingTimeoutRef.current ) clearTimeout( aiTutorSpeakingTimeoutRef.current );

						aiTutorSpeakingTimeoutRef.current = setTimeout( () => {
							setAiTutorIsSpeaking( false );
						}, 900 );

					},
				onError: ( errorInfo ) => {

					console.error( 'Tutor AI onError:', errorInfo );
					const errorMessage = typeof errorInfo === 'string'
						? errorInfo
						: (
							errorInfo && (
								errorInfo.message
								|| errorInfo.reason
								|| errorInfo.error
								|| ( () => {
									try { return JSON.stringify( errorInfo ); }
									catch ( e ) { return String( errorInfo ); }
								} )()
							)
						) || 'Errore sconosciuto';

					console.error( 'Tutor AI parsed error:', errorMessage );
					const errorText = String( errorMessage || '' ).toLowerCase();

					if ( errorText.includes( 'quota' ) ) {
						setCurrentError( 'Tutor AI non disponibile: quota ElevenLabs esaurita. Dettaglio: ' + errorMessage );
						return;
					}

					if ( errorText.includes( 'max_duration_exceeded' ) ) {
						setCurrentError( 'Sessione Tutor AI terminata: durata massima raggiunta. Dettaglio: ' + errorMessage );
						return;
					}

					setCurrentError( 'Errore durante la sessione Tutor AI: ' + errorMessage );

				}
			} );

			return true;

			} catch ( err ) {

			console.error( 'Error during startAiTutorSession:', err );
				aiConversation = null;
				if ( aiTutorOutputMonitorRef.current ) {
					clearInterval( aiTutorOutputMonitorRef.current );
					aiTutorOutputMonitorRef.current = null;
				}
				setIsAiTutorOpen( false );
				setAiTutorStatus( 'disconnected' );
				setAiTutorMode( 'idle' );
				setAiTutorIsSpeaking( false );
				setCurrentError( 'Impossibile avviare il Tutor AI. Verificare il microfono e riprovare.' );

			return false;

		}

	};

	/* */

	const cleanUserData = () => {

		console.log( 'cleanUserData' );

		setTeacher( false );

		setOpenSendAttachment( null );
		setOpenActiveAttachment( null );
		setActiveAttachments( null );

		setCurrentLesson( null );
		setCurrentLessonAttachments( null );

		setGlobalRoomUsers( {} );
		setActiveGroups( {} );
		setCurrentUserGroup( "0" );
		setCurrentGroupDetails( null );

		void stopAiTutorSession( { silent: true, suppressErrors: true } );

			setOpenSideBar( false );
                setOpenCloud( false );
                setOpenSideAttachment( false );
			setIsAiTutorOpen( false );
			setAiTutorStatus( 'disconnected' );
			setAiTutorMode( 'idle' );
			setAiTutorIsSpeaking( false );

                setIsRecording( [] );
                setActiveRecordings( null );
		setPreviewRecording( null );
		setOpenActiveRecordings( false );
		setSelectedRecordings( null );

                setCurrentQuiz( null );
                setCurrentQuizIndex( 0 );

                // TODO -- verificare perché riattivando questo comando, dopo aver fatto un quiz se uno studente riceve un kickoff questo fa scattare l'hook di update user che ne reimposta i dati compromettendo il kickoff
                //setCurrentExecution( null );

                setIsScreenSharing( false );
                setLocalScreenStream( null );
                setRemoteScreenStream( null );
                setRemoteScreenOwner( null );
                setShouldResumeScreenShare( false );
                resumeScreenShareRef.current = false;

		setUserData( null );		

		localStorage.removeItem('opedialingue_user');

		if ( isMobileDevice() )  disableNoSleep();

	};

	/* */

	const toggleAiTutor = () => {
		if ( isAiTutorOpen || aiTutorStatus === 'connected' || aiTutorStatus === 'connecting' ) void stopAiTutorSession();
		else void startAiTutorSession();

	};

	/* */

	const reloadApp = () => {

		console.log( 'reloadApp' );

		window.location.reload();

	};

	/* */

	async function sendSessionLog( err ) {	

		const err_msg = err + ' *** userAgent: ' + navigator.userAgent;
		
		console.log( 'sendSessionLog:', err_msg );
		
		try {

			setIsLoading( true );

			const params = {
				user_name: refAuth.current.name,
				client_error: err_msg 
			};
			
			const endpoint = config.API_BASENAME + '/session/' + refAuth.current.session_id + '/log/';
			const apiData = await apiRequest( endpoint, 'POST', refAuth.current.tokenDjango, params );
			
			console.log( 'apiData:', apiData );

			setIsLoading( false );
			
			if ( apiData.result === "error" ) {
				
				setCurrentError( 'Errore durante la procedura di invio log sessione.' );
				
			}
			
		} catch( err ) {
			
			console.error( 'Error during sendSessionLog:', err );

			setCurrentError( 'Error during sendSessionLog: ' + err );

			setIsLoading( false );
		
		}
		
	};

	/*** BeeTalk ***/

	const joinGlobal = ( name, is_teacher, session_id ) => {

		console.log( '*** joinGlobal', name, is_teacher, session_id );		
		
		if ( rg  && rg.isOpen() ) {
			
			console.log( 'Already connected to RoomGlobal' );

		} else {

			rg = new RoomGlobal( socketMessage, 'GLOBAL_' + session_id, name, is_teacher, session_id, roomGlobalOpen, roomUpdate, onRoomGlobalError );

		}
	
	};	

	const onRoomGlobalError = ( err ) => {

		console.error( '*** onRoomGlobalError:', err );

		sendSessionLog( '*** onRoomGlobalError: ' + err );

		setCurrentError('ATTENZIONE! Qualcosa è andato storto durante il caricamento della sessione o la precedente sessione non era stata chiusa correttamente. Riprovare a collegarsi.');

		sendLogout();

	};

	const roomGlobalOpen = () => {

		console.log( '*** roomGlobalOpen' );

		joinRoom( refAuth.current.name, refAuth.current.isTeacher, "0", refAuth.current.cloud_id, refAuth.current.session_id );

	};
	
	const joinRoom = ( name, is_teacher, room_id, opedia_id, session_id ) => {

		console.log( '*** joinRoom', name, is_teacher, room_id, opedia_id, session_id );
		
		if ( rc && rc.isOpen() ) {
			
			console.log( 'Already connected to a RoomClient' );

		} else {

			rc = new RoomClient( remoteAudiosElem, mediasoupClient, socket, room_id, name, is_teacher, opedia_id, session_id, roomOpen, roomUpdate, onRoomClientError );

			addListeners( rc );

		}
	
	};

	const onRoomClientError = ( err ) => {

		console.error( '*** onRoomClientError:', err );

		//let r = window.confirm( 'Attenzione! Rilevato problema di stabilità audio. Accedere nuovamente alla lezione per ripristinare le funzionalità.' );
		//if ( r ) sendLogout();
		//else sendLogout();

		//alert( 'Attenzione! Rilevato problema di stabilità audio. La connessione verrà ripristinata.' );

		sendSessionLog( '*** onRoomClientError: ' + err );

		//window.location.reload();

	};

        const addListeners = ( client ) => {

                console.log( '*** addListeners' );

                client.on( RoomClient.EVENTS.stopAudio, () => {

                        console.log('[EVENT] STOP AUDIO');

                }) ;

                client.on( RoomClient.EVENTS.startAudio, () => {

                        console.log('[EVENT] START AUDIO');

                } );

                client.on( RoomClient.EVENTS.startScreen, async ( payload ) => {

                        console.log('[EVENT] START SCREEN', payload );

                        if ( payload && payload.origin === 'local' ) {

                                if ( payload.stream ) setLocalScreenStream( payload.stream );
                                setIsScreenSharing( true );
                                persistScreenShareState( true );
                                setShouldResumeScreenShare( false );

                                let shouldForceAudio = true;

                                if ( rc && typeof rc.isProducerPaused === 'function' ) {
                                        const audioPaused = rc.isProducerPaused( RoomClient.mediaType.audio );
                                        if ( audioPaused === false ) shouldForceAudio = false;
                                }

                                if ( shouldForceAudio ) {
                                        const resumed = await playMute( true );
                                        forcedShareAudioRef.current = Boolean( resumed );
                                }
                                else {
                                        forcedShareAudioRef.current = false;
                                }

                        }
                        else if ( payload && payload.origin === 'remote' ) {

                                if ( payload.stream ) setRemoteScreenStream( payload.stream );
                                setRemoteScreenOwner( payload.producerName || null );

                        }

                } );

                client.on( RoomClient.EVENTS.stopScreen, async ( payload ) => {

                        console.log('[EVENT] STOP SCREEN', payload );

                        if ( payload && payload.origin === 'local' ) {

                                if ( !payload.silent ) {

                                        const msg = {
                                                type: 'stopshare',
                                                data: {
                                                        user: refAuth.current ? refAuth.current.name : null
                                                }
                                        };

                                        if ( rg && refAuth.current ) rg.sendMessage( msg );

                                }

                                setLocalScreenStream( null );
                                setIsScreenSharing( false );
                                persistScreenShareState( false );
                                setShouldResumeScreenShare( false );
                                resumeScreenShareRef.current = false;

                                if ( forcedShareAudioRef.current ) {
                                        await playMute( false );
                                        forcedShareAudioRef.current = false;
                                }

                                if ( payload.reason && payload.reason !== 'manual' ) {

                                        setCurrentMessage( 'Condivisione schermo terminata.' );

                                }

                        }
                        else if ( payload && payload.origin === 'remote' ) {

                                setRemoteScreenStream( null );
                                setRemoteScreenOwner( null );

                        }

                } );

                client.on( RoomClient.EVENTS.exitRoom, () => {

                        console.log('[EVENT] EXIT ROOM');

                        setLocalScreenStream( null );
                        setRemoteScreenStream( null );
                        setRemoteScreenOwner( null );
                        setIsScreenSharing( false );

                } );

        };

	const roomOpen = () => {

		console.log( '*** roomOpen' );

		initLocalAudio();

	};

	const initLocalAudio = () => {

		setIsLoading( true );

		setTimeout( function() {

			console.log( '*** initLocalAudio', refCurrentUserGroup.current );
	
                        rc.produce( RoomClient.mediaType.audio ).then( async function() {

                                console.log('*** produced', rc );

                                await rc.pauseProducer( RoomClient.mediaType.audio );

                                setIsLoading( false );

                                setIsUserReady( true );

			});
	
		}, config.TIMEOUT_DELAY );

	};
	
	const closeLocalAudio = () => {

		if ( rc ) {

			console.log( '*** closeLocalAudio' );

			rc.closeProducer( RoomClient.mediaType.audio );

			setIsLoading( true );

			setTimeout( function() {

				rc.exit( false, function() {

					console.log('*** room exit done...');

				} );

				rc = null;

				setIsLoading( false );

				setIsUserReady( false );

			}, config.TIMEOUT_DELAY );

		}

	};

        const playMute = async ( shouldTalk ) => {

                console.log('*** playMute', shouldTalk );

                if ( !rc || !refAuth.current || !refAuth.current.name ) return false;

                const userName = refAuth.current.name;

                let operationResult = false;

                if ( shouldTalk ) {
                        operationResult = await rc.resumeProducer( RoomClient.mediaType.audio );
                }
                else {
                        operationResult = await rc.pauseProducer( RoomClient.mediaType.audio );
                }

                if ( !operationResult ) {

                        const errorMessage = shouldTalk
                                ? 'Impossibile attivare il microfono. Verificare le impostazioni audio e riprovare.'
                                : 'Impossibile disattivare il microfono. Riprovare più tardi.';

                        setCurrentError( errorMessage );

                        return false;

                }

                userGlobalTalk( userName, shouldTalk );

                if ( rg ) {

                        const msg = {
                                type: shouldTalk ? 'talk' : 'pause',
                                data: {
                                        user: userName
                                }
                        };

                        rg.sendMessage( msg );

                }

                return true;

        };

        const persistScreenShareState = ( isSharing ) => {

                if ( !refAuth.current ) return;

                const user = { ...refAuth.current };

                user.isScreenSharing = isSharing;
                user.screenShareTimestamp = isSharing ? Date.now() : null;

                resumeScreenShareRef.current = isSharing;

                setUserData( user );

        };

        const shareScreen = async ( shouldShare, options = {} ) => {

                const { isAuto = false } = options;

                console.log('*** shareScreen requested', shouldShare, options );

                if ( !rc || ( typeof rc.isOpen === 'function' && !rc.isOpen() ) ) {

                        if ( shouldShare ) {

                                if ( isAuto ) setCurrentMessage( 'Ripristino della condivisione schermo non disponibile: connessione non pronta.' );
                                else setCurrentError( 'Impossibile gestire la condivisione schermo in questo momento. Riprovare più tardi.' );

                        }

                        return false;

                }

                if ( shouldShare ) {

                        const currentUserName = refAuth.current ? refAuth.current.name : null;
                        const activeShare = Object.values( refGlobalUsers.current || {} ).find( ( user ) => user && user.isSharing && user.name !== currentUserName );

                        if ( activeShare ) {

                                const message = `Condivisione schermo non disponibile: ${ activeShare.name } sta già condividendo.`;

                                if ( isAuto ) setCurrentMessage( message );
                                else setCurrentError( message );

                                return false;

                        }

                        try {

                                const result = await rc.produce( RoomClient.mediaType.screen );

                                if ( result && result.stream ) setLocalScreenStream( result.stream );
                                setIsScreenSharing( true );

                                const msg = {
                                        type: 'startshare',
                                        data: {
                                                user: currentUserName
                                        }
                                };

                                if ( rg && refAuth.current ) rg.sendMessage( msg );

                                return true;

                        }
                        catch( err ) {

                                console.error('Errore shareScreen start:', err );

                                setIsScreenSharing( false );
                                setLocalScreenStream( null );
                                persistScreenShareState( false );

                                if ( err && err.name === 'NotAllowedError' ) {

                                        if ( isAuto ) setCurrentMessage( 'Condivisione schermo annullata: consentire nuovamente l\'accesso per riprendere.' );
                                        else setCurrentError( 'Condivisione schermo annullata: autorizzazione negata.' );

                                }
                                else {

                                        if ( isAuto ) setCurrentError( 'Impossibile ripristinare automaticamente la condivisione schermo. Riprovare manualmente.' );
                                        else setCurrentError( 'Si è verificato un errore durante l\'avvio della condivisione schermo.' );

                                }

                                return false;

                        }

                }

                if ( isScreenSharing && refAuth.current ) {

                        const msg = {
                                type: 'stopshare',
                                data: {
                                        user: refAuth.current.name
                                }
                        };

                        if ( rg ) rg.sendMessage( msg );

                }

                rc.closeProducer( RoomClient.mediaType.screen, { reason: 'manual', silent: true } );
                setLocalScreenStream( null );
                setIsScreenSharing( false );
                persistScreenShareState( false );
                setShouldResumeScreenShare( false );
                resumeScreenShareRef.current = false;

                return true;

        };

        useEffect( () => {

                if ( !shouldResumeScreenShare ) return;

                if ( !resumeScreenShareRef.current ) {

                        setShouldResumeScreenShare( false );
                        return;

                }

                let cancelled = false;

                const resumeShare = async () => {

                        if ( isScreenSharing ) {

                                if ( !cancelled ) setShouldResumeScreenShare( false );

                                return;

                        }

                        const success = await shareScreen( true, { isAuto: true } );

                        if ( cancelled ) return;

                        if ( !success ) resumeScreenShareRef.current = false;

                        setShouldResumeScreenShare( false );

                };

                resumeShare();

                return () => {

                        cancelled = true;

                };

        }, [ shouldResumeScreenShare, isScreenSharing, shareScreen ] );

        const roomUpdate = ( action, data, room_id ) => {

		//console.log( '*** roomUpdate', action, data, room_id );

		switch ( action ) {

			case 'add':

				if ( !refGlobalUsers.current[ data.producer_name ] ) addGlobalUser( data.producer_name, data.is_teacher, room_id );

				//addRoomUser( data.producer_id, data.producer_name, data.is_teacher );

				break;

			case 'delete':

				//removeRoomUser( data.producer_id );	
				
				break;

			case 'message':

				handleMessages( data );

				break;	

			default:
				break;

		}	

	};

	const requestStudentScreenShare = ( studentName ) => {

		console.log( `Requesting screen share from ${studentName}` );

		if ( rg ) {

			const msg = {
				type: 'teacher_requests_your_screen_share',
				data: {
					studentName: studentName,
					teacherName: authUser.name
				}
			};

			rg.sendMessage( msg );

		}

	};

	const acceptShareRequest = () => {
		console.log('Accepted screen share request');
		shareScreen(true);
		setScreenShareRequest(null);
	};

	const rejectShareRequest = () => {
		console.log('Rejected screen share request');
		if (rg && screenShareRequest) {
			const msg = {
				type: 'student_rejected_share_request',
				data: { studentName: authUser.name, teacherName: screenShareRequest.from }
			};
			rg.sendMessage(msg);
		}
		setScreenShareRequest(null);
	};

	const handleMessages = ( data ) => {

		const type = data.data.type;
		const message = data.data.data;

		switch ( type ) {

			case 'globaldelete':

				removeGlobalUser( message.user );	
				
				break;

			case 'active':

				userGlobalActive( message.user, true );

				break;
				
			case 'inactive':
				
				userGlobalActive( message.user, false );

				break;

			case 'talk':

				userGlobalTalk( message.user, true );
				
				break;		
	
			case 'pause':
	
				userGlobalTalk( message.user, false );
		
				break;	
				
			case 'startshare':
	
				userGlobalShare( message.user, true );
		
				break;
			
			case 'stopshare':
	
				userGlobalShare( message.user, false );
		
				break;

			case 'lesson':

				setCurrentLesson( message );

				break;

			case 'updatequiz':

				if ( message && !refAuth.current.isTeacher ) {

					let user = { ...refAuth.current };

					user.hasQuizDone = false;

					//setAuthUser( user );
					setUserData( user );

					setCurrentQuiz( message );
					prepareCurrentExecution( message );

				}

				break;
				
			case 'quizdone':

				//if ( refAuth.current.isTeacher ) userGlobalQuizDone( message.user, true );
				userGlobalQuizDone( message.user, true );
		
				break;

			case 'attachment':

				setActiveAttachments( message );

				break;

			case 'updatedata':

				setCurrentLesson( message.currentLesson );
				setActiveAttachments( message.activeAttachments );
				setCurrentQuiz( message.currentQuiz );

				if ( message.currentQuiz && !refAuth.current.currentExecution ) prepareCurrentExecution( message.currentQuiz );
				
				break;

			case 'changegroup':

				changeGroup( message.user, message.group );
	
				break;	

			case 'resetgroups':
	
				setCurrentUserGroup( "0" );
				changeGroup( refAuth.current.name, "0", true );
		
				break;		

			case 'kickoff':	

				if ( refAuth.current.name === message.user ) sendLogout();

				break;

			case 'kickoffall':

				sendLogout();

				break;

			case 'teacher_requests_your_screen_share':
				if (refAuth.current && refAuth.current.name === message.studentName) {
					console.log('Received teacher_requests_your_screen_share', message);
					setScreenShareRequest({ from: message.teacherName });
				}

				break;

			case 'student_rejected_share_request':
				if ( refAuth.current.isTeacher ) setCurrentMessage(`Lo studente ${message.studentName} ha rifiutato la condivisione.`);
				break;

			default:
				break;	
				
		}

	};	

	/******/

	/* */
  
	return (
		<coreContext.Provider value={
				{ 
					onBlur,
					onFocus,
					onBeforeUnload,
					isOffline,
					enableNoSleep,
					isLoading, 
        			setIsLoading,
					authUser, 
					setAuthUser: setUserData, 
					sendLogout,
					cleanUserData,
					currentError, 
					setCurrentError,
					currentMessage,
					setCurrentMessage,
					isTeacher, 
					setTeacher, 
					globalRoomUsers,
					setGlobalRoomUsers,
					currentUserJoin,					
					userKickOff,
					currentUserLeave,
					openSendAttachment,
					setOpenSendAttachment,
					openAttachment,
					openActiveAttachment,
					setOpenActiveAttachment,
					activeAttachments,
					setActiveAttachments,
					currentLesson,
					setCurrentLesson,
					activeGroups,
					setActiveGroups,
					changeGroup,
					currentLessonAttachments,
					setCurrentLessonAttachments,					
                                        playMute,
                                        shareScreen,
                                        isScreenSharing,
                                        localScreenStream,
                                        remoteScreenStream,
                                        remoteScreenOwner,
                                        currentUserGroup,
                                        setCurrentUserGroup,
					sendAttachmentMsg,
					sendChangeGroupMsg,
					currentGroupDetails,
					setCurrentGroupDetails,
					openSideBar,
					setOpenSideBar,
					openCloud,
					setOpenCloud,
					openSideAttachment,
					setOpenSideAttachment,
					isAiTutorOpen,
					aiTutorStatus,
					aiTutorMode,
					aiTutorIsSpeaking,
					toggleAiTutor,
					isRecording,
					setIsRecording,
					activeRecordings,
					setActiveRecordings,
					openActiveRecordings,
					setOpenActiveRecordings,
					previewRecording,
					setPreviewRecording,
					selectedRecordings,
					setSelectedRecordings,
					sendSaveLesson,
					currentQuiz,
					setCurrentQuiz,
					currentQuizIndex,
					setCurrentQuizIndex,
					quizDone,
					quizClose,
					currentExecution,
					setCurrentExecution,
					requestStudentScreenShare,
					screenShareRequest,
					acceptShareRequest,
					rejectShareRequest
				}
			}>
			{ children }
		</coreContext.Provider>
	);
  
}

/**
A wrapper for <Route> that redirects to the login
screen if you're not yet authenticated.
**/

export function PrivateRoute( { children, ...rest } ) {
	
	const { authUser } = useCore();
	
	return (
		<Route
		  {...rest}
		  render={({ location }) =>
		    authUser ? (
		      children
		    ) : (
		      <Redirect
		        to={{
		          pathname: "/login",
		          state: { from: location }
		        }}
		      />
		    )
		  }
		/>
	);
  
}

/** apiRequest **/

export function apiRequest( endpoint, method, token, params ) {
			
	console.log( 'API:', endpoint, method );
	
	if ( params ) console.log( 'Params:', params );
	
	let headers = {
        "Content-Type": "application/json"
    };
	
	if ( token ) {
		
		console.log( 'apiToken:', token );
		
		headers = {
			"Accept": "application/json",
	        "Content-Type": "application/json",
	        "Authorization": "Token " + token
	    }
		
	}
	
	return fetch( endpoint, {
		method: method,
		headers: headers,
		body: JSON.stringify( params )
	} )
	.then( resp => {
		
		return resp.json();
		
	} );

}

/* Utility */

export function isMobileDevice() {

	let check = false;
	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	return check;

};
	
export function youtubeParser( url ) {

	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
	var match = url.match( regExp );
	
	return ( match&&match[7].length==11 )? match[7] : false;

};

export function shuffleArray( array ) {

	let new_array = [ ...array ];

	for ( let i = new_array.length - 1; i > 0; i-- ) {

		const j = Math.floor( Math.random() * ( i + 1 ) );
		const temp = new_array[i];

		new_array[i] = new_array[j];
		new_array[j] = temp;

	}

	return new_array;

}

export const recordAudio = () =>
new Promise( async resolve => {

	const stream = await navigator.mediaDevices.getUserMedia( { audio: true } );

	const mediaRecorder = new MediaRecorder( stream );
	const audioChunks = [];

	mediaRecorder.addEventListener( "dataavailable", event => {
		
		audioChunks.push( event.data );

	});

	const start = () => mediaRecorder.start();

	const stop = () =>
	new Promise( resolve => {

		mediaRecorder.addEventListener( "stop", () => {

			const audioBlob = new Blob( audioChunks, { 'type': 'audio/mp3' } );
			const audioUrl = URL.createObjectURL( audioBlob );

			const reader = new window.FileReader();
			reader.readAsDataURL( audioBlob ); 

			reader.onloadend = function() {
				
				const audioBase64 = reader.result;

				resolve( { audioBlob, audioUrl, audioBase64 } );

			}

		});

		mediaRecorder.stop();

	});

	resolve( { start, stop } );
});
